import React, { useEffect, useState } from 'react';
/* Componentes */
import VideoToken from '../../components/new_videotoken'
/* Funciones */
import { validarOtorganteCDC } from '../../services/data'

const Index = () => {

    /* Hooks */
    const [apikey, setApikey] = useState('')
    const [uuidCliente, setUuidCliente] = useState('')
    const [uuidTransaccion, setUuidTransaccion] = useState('')
    const [nextStep, setNextStep] = useState('')
    const [dataOtorgante, setDataOtorgante] = useState([])

    useEffect(() => {

        const apikeyOtorgante = localStorage.getItem("apikeyOtorgante")
        if (apikeyOtorgante) {
            setApikey(apikeyOtorgante)
        }

        const uuidUser = localStorage.getItem("uuidUser")
        if (uuidUser) {
            setUuidCliente(uuidUser)
        }

        const uuidTrx = localStorage.getItem("uuidTrx");
        if (uuidTrx) {
            setUuidTransaccion(uuidTrx)
        }

        const dataOtorganteLS = localStorage.getItem("dataOtorgante")
        if (dataOtorganteLS) {
            let dataOtorganteJSON = JSON.parse(dataOtorganteLS)
            setDataOtorgante(dataOtorganteJSON)
        }

        setNextStep('/pdf_token_result')

    }, []);

    return (
        <>
            <VideoToken
                apikey={apikey}
                uuidCliente={uuidCliente}
                uuidTransaccion={uuidTransaccion}
                dataOtorgante={dataOtorgante}
                service_call={'videotoken-pdf'}
                previousStep={`/pdf_token?uuid=${uuidCliente}&idOtorgante=${localStorage.getItem("uuidOtorgante")}&uuidTrx=${uuidTransaccion}&fecha=${localStorage.getItem("fechavigencia")}`}
                nextStep={nextStep}
                cancelStep={`/selfie_pdf`}
                type='pdf'
                intents={'5'}
            />
        </>
    );
}

export default Index;
